'use client';

import { useProjectResponseAudioRecord } from '@/shared-survey';

interface UseSurveyAiFormsAudioProps {
  organizationId: string | undefined;
  anonymous: boolean | null | undefined;
}

export function useSurveyAiFormsAudio({
  organizationId,
  anonymous,
}: UseSurveyAiFormsAudioProps) {
  const { reset, createMessageAsset, createMessageAssetLoading, lock, unlock } =
    useProjectResponseAudioRecord(organizationId, anonymous);

  return {
    resetAudioRecord: reset,
    createMessageAudioAsset: createMessageAsset,
    isUploadingAudio: createMessageAssetLoading,
    lockAudioRecord: lock,
    unlockAudioRecord: unlock,
  };
}

export type SurveyAiFormsAudio = ReturnType<typeof useSurveyAiFormsAudio>;
